export default {
  /* Navigation Stacks */
  Lobby: 'LobbyStack',
  Root: 'RootStack',

  /* Not-Auth Screens */
  Start: 'StartScreen',
  Login: 'LoginScreen',
  SSOLogin: 'SSOLoginScreen',
  Signup: 'SignupScreen',
  FacebookLogin: 'FacebookLoginScreen',
  TermsAndConditions: 'TermsAndConditionsScreen',
  TrackingURL: 'TrackingURL',

  /* Lobby Screens */
  Home: 'HomeScreen',
  Slots: 'SlotGamesScreen'
  /** DO NOT USE THIS FOR STAR */
  ,
  Tables: 'TableGamesScreen',
  VIP: 'VIPGamesScreen',
  VipAccessFlow: 'VipAccessScreen',
  Tournaments: 'TournamentsScreen',
  Favourites: 'FavouritesScreen',
  FavouriteListDialogue: 'FavouriteListDialogue',
  FavouriteOnboardingDialogue: 'FavouriteOnboardingDialogue',
  FavouritesExpired: 'FavouritesExpired',
  FavouritesInformation: 'FavouritesInformation',
  FavouritesUnlocked: 'FavouritesUnlocked',
  Game: 'GameScreen',
  Shop: 'ShopScreen',
  FinishWebPurchase: 'finishpurchase',
  PurchaseFlow: 'PurchaseFlow',
  PurchaseSucceeded: 'PurchaseSucceeded',

  /* Modals */
  Leaderboards: 'LeaderboardsScreen',
  VideoAds: 'VideoAdsScreen',
  Congrats: 'CongratsScreen',
  RewardCenter: 'RewardCenterScreen',
  Messages: 'MessagesScreen',
  Settings: 'SettingsScreen',
  News: 'NewsScreen',
  DailySpin: 'DailySpinScreen',
  SessionExpired: 'SessionExpiredScreen',
  LimitedTimeOffer: 'LimitedTimeOffer',
  RateUs: 'RateUsScreen',
  WatchAndEarnInfo: 'WatchAndEarnInfo',
  OutOfCoin: 'OutOfCoinScreen',
  LinkAccount: 'LinkAccountScreen',
  LinkAccountForm: 'LinkAccountForm',
  ConnectionLost: 'ConnectionLost',
  ComingSoon: 'ComingSoon',
  RewardCenterOnboarding: 'RewardCenterOnboarding',
  LinkCardOnboarding: 'LinkCardOnboarding',
  DailySpinOnboarding: 'DailySpinOnboarding',
  WelcomeBonus: 'WelcomeBonus',
  OneTimePassword: 'OneTimePassword',
  DynamicPopups: 'DynamicPopups',

  /* Critical Path Flows */
  UpgradeAccountFlow: 'UpgradeAccountFlow',
  CurrencySelector: 'CurrencySelectorScreen',
  LinkLoyaltyCard: 'LinkLoyaltyCard',
  KYCLockout: 'KYCLockoutScreen',

  /* Temporary Screens */
  Audio: 'AudioView',
  Banner: 'BannerView',
  GameUnavailable: 'GameUnavailableView',
  GenericMessage: 'GenericMessage',
  BonusLinkMessage: 'BonusLinkMessage',
  CheatMenu: 'CheatMenu',
  RegisterRewardCard: 'RegisterRewardCard',
  ForgotPassword: 'ForgotPassword',
  AdBlocker: 'AdBlocker',
  SneakPeekOnboarding: 'SneakPeekOnboarding',
  Missions: 'MissionsScreen'
};